import { SuklPharmaceuticalFormGridObject } from '@libs/types/src/list/object-type/sukl-pharmaceutical-form.object';
import { GridInput } from '@it2go/data-grid';
import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../modules/content/service/gql.service-v2';
import { filterFrag } from '../types/filter.types';
import { suklPharmaceuticalFormFrag } from '../types/sukl-pharmaceutical-form.types';

@Injectable({ providedIn: 'root' })
export class ListSuklPharmaceuticalFormService extends GqlServiceV2 {
    public getListSuklPharmaceuticalForms(input: GridInput, frag = suklPharmaceuticalFormFrag) {
        return this.query<SuklPharmaceuticalFormGridObject>(
            `
                query($input: GridInput!) {
                    suklPharmaceuticalForm {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }
}
